// ============================================================
// ARTÍCULOS DEL BLOG — DentalAi
// Añade o edita artículos aquí. Tipos de bloque: p, h2, li, quote
// ============================================================

export const BLOG_POSTS = [
  {
    slug: "que-es-un-no-show-dental",
    title: "Qué es un no-show dental y cuánto le cuesta realmente a tu clínica",
    description:
      "Qué es un no-show, por qué una hora de sillón vacía no se recupera y cómo calcular el coste mensual que las ausencias generan en tu clínica dental.",
    category: "Gestión de clínica",
    date: "2026-10-06",
    readTime: "5 min",
    content: [
      {
        type: "p",
        text: "Un no-show es una cita programada a la que el paciente no acude y que, con tan poca antelación, normalmente no puede ser ocupada por otra persona. En una clínica dental no es solo un inconveniente de agenda: es una unidad de capacidad productiva que desaparece para siempre.",
      },
      { type: "h2", text: "Por qué una hora de sillón vacía no se recupera" },
      {
        type: "p",
        text: "A diferencia de una tienda, una clínica no puede “vender” esa hora más tarde. El gabinete estuvo preparado, el equipo estuvo disponible y los materiales, en muchos casos, ya estaban listos. Cuando el paciente no aparece, esa capacidad se pierde sin posibilidad de recuperación.",
      },
      { type: "h2", text: "El coste real va más allá de la cita perdida" },
      { type: "li", text: "La facturación directa del tratamiento que no se realiza." },
      { type: "li", text: "El coste del equipo y del gabinete durante esa hora vacía." },
      { type: "li", text: "El tiempo de recepción dedicado a llamar y reordenar la agenda." },
      { type: "li", text: "El efecto arrastre: tratamientos de varias sesiones que se desplazan." },
      { type: "li", text: "La oportunidad perdida de haber atendido a otro paciente de la lista de espera." },
      { type: "h2", text: "Cómo calcular lo que pierdes cada mes" },
      {
        type: "p",
        text: "La fórmula orientativa es sencilla: multiplica tus citas mensuales por tu porcentaje de no-shows y por el precio medio de una cita. El resultado es tu pérdida mensual estimada. Multiplícala por doce y tendrás la dimensión anual del problema.",
      },
      {
        type: "quote",
        text: "Puedes hacer este cálculo en segundos con la calculadora de nuestra página principal: introduce tus citas al mes, tu porcentaje de no-shows y tu precio medio.",
      },
      { type: "h2", text: "Qué puedes hacer a partir de ahí" },
      {
        type: "p",
        text: "El primer paso es medir. El segundo es sistematizar: confirmaciones claras por los canales que cada paciente realmente usa, detección de respuestas ambiguas y una lista de espera capaz de reaccionar en minutos cuando alguien cancela. Automatizar esas tres piezas es exactamente lo que hace DentalAi.",
      },
    ],
  },
  {
    slug: "reducir-ausencias-pacientes",
    title: "7 formas de reducir las ausencias de pacientes sin saturar a recepción",
    description:
      "Estrategias prácticas para reducir no-shows y cancelaciones de última hora en tu clínica dental sin cargar de trabajo manual a tu equipo de recepción.",
    category: "Reducción de no-shows",
    date: "2026-10-06",
    readTime: "6 min",
    content: [
      {
        type: "p",
        text: "Reducir las ausencias no consiste en llamar más, sino en confirmar mejor. Estas siete prácticas funcionan especialmente bien cuando se aplican de forma sistemática y no dependen de que alguien en recepción recuerde hacerlas.",
      },
      { type: "h2", text: "1. Pide una confirmación explícita, no un “vale”" },
      {
        type: "p",
        text: "Un recordatorio que no exige respuesta genera silencio, no certeza. Diseña tus mensajes para que el paciente responda SÍ o CAMBIAR. Una respuesta clara convierte la agenda en un dato fiable.",
      },
      { type: "h2", text: "2. Trata las respuestas ambiguas como no confirmadas" },
      {
        type: "p",
        text: "“Creo que sí”, “te aviso” o “intentaré ir” no son confirmaciones. Clasifícalas como pendientes, haz una pregunta de aclaración y, si no hay respuesta clara, escala el caso a una persona del equipo.",
      },
      { type: "h2", text: "3. Adapta el canal a cada paciente" },
      {
        type: "p",
        text: "No todos responden por igual: WhatsApp, SMS, email o llamada automática rinden diferente según el perfil. Usa el canal que cada paciente realmente atiende, no el mismo para todos.",
      },
      { type: "h2", text: "4. Personaliza el mensaje según la cita" },
      {
        type: "p",
        text: "No es lo mismo una revisión de quince minutos que una sesión de implantología de hora y media. Indicar el procedimiento, la duración y qué debe hacer el paciente para confirmar aumenta la claridad y la respuesta.",
      },
      { type: "h2", text: "5. Refuerza las citas de alto valor" },
      {
        type: "p",
        text: "Para tratamientos largos o de alto valor, valora depósitos, tarjeta de garantía o una confirmación reforzada, siempre según las políticas de tu clínica y la normativa aplicable.",
      },
      { type: "h2", text: "6. Mantén una lista de espera que reaccione en minutos" },
      {
        type: "p",
        text: "Una cancelación es recuperable solo si el hueco se ofrece rápido a alguien compatible. Una lista de espera en papel o en la memoria de recepción llega tarde; una lista digital filtrada por tratamiento y disponibilidad llega a tiempo.",
      },
      { type: "h2", text: "7. Mide tu tasa de no-shows cada mes" },
      {
        type: "p",
        text: "Lo que no se mide no mejora. Registra ausencias, cancelaciones y huecos recuperados para saber si tus acciones funcionan y dónde sigue escapándose la facturación.",
      },
      {
        type: "quote",
        text: "Las siete prácticas anteriores se pueden automatizar: confirmación multicanal, detección de ambigüedad, priorización por riesgo y rescate de huecos. Es el sistema completo de DentalAi.",
      },
    ],
  },
  {
    slug: "confirmaciones-whatsapp-sms-llamada",
    title: "Confirmaciones por WhatsApp, SMS o llamada: qué canal elegir para cada paciente",
    description:
      "Comparativa práctica de WhatsApp, SMS, email y llamada automática para confirmar citas en clínicas dentales, y cómo combinarlos según el riesgo de ausencia.",
    category: "Comunicación con pacientes",
    date: "2026-10-06",
    readTime: "5 min",
    content: [
      {
        type: "p",
        text: "No existe un canal perfecto para todos los pacientes. La pregunta correcta no es “¿WhatsApp o SMS?”, sino “¿qué canal tiene más probabilidades de obtener una respuesta clara de esta persona, para esta cita, con esta antelación?”.",
      },
      { type: "h2", text: "WhatsApp: el canal conversacional" },
      {
        type: "p",
        text: "Alta tasa de lectura y respuesta cómoda para la mayoría de pacientes. Ideal para confirmaciones con botones de respuesta y para ofrecer franjas alternativas cuando alguien no puede acudir. Requiere cumplir las políticas de la plataforma y contar con el consentimiento adecuado.",
      },
      { type: "h2", text: "SMS: directo y universal" },
      {
        type: "p",
        text: "Llega a cualquier móvil sin apps ni datos. Perfecto para recordatorios breves con respuesta simple (SÍ / CAMBIAR) y para pacientes menos digitales. Menos espacio para contexto, así que el mensaje debe ser muy claro.",
      },
      { type: "h2", text: "Email: el canal del detalle" },
      {
        type: "p",
        text: "Útil para citas de alto valor o tratamientos que requieren preparación, porque permite incluir instrucciones completas. Como canal de confirmación de última hora funciona peor: se lee con menos inmediatez.",
      },
      { type: "h2", text: "Llamada automática: el escalado eficaz" },
      {
        type: "p",
        text: "Resérvala para citas de alto riesgo o de gran valor, cuando los canales escritos no han obtenido respuesta clara. Es más intrusiva, pero precisamente por eso consigue atención cuando los demás canales han fallado.",
      },
      { type: "h2", text: "La respuesta correcta: combinarlos por riesgo" },
      {
        type: "p",
        text: "Un flujo inteligente empieza por el canal preferido del paciente, insiste por un segundo canal si no hay respuesta clara y escala a llamada o a recepción solo cuando el riesgo lo justifica. Así el equipo humano interviene únicamente donde aporta valor.",
      },
      {
        type: "quote",
        text: "DentalAi orquesta exactamente este flujo: elige el canal, interpreta la respuesta, detecta ambigüedad y escala a recepción solo cuando hace falta criterio humano.",
      },
    ],
  },
];

export const getPost = (slug) => BLOG_POSTS.find((p) => p.slug === slug);
